export function productViewSwitch() {
  document.addEventListener('DOMContentLoaded', function () {
    const viewSwitchBtn = document.querySelector('.viewSwitch');
    const productList = document.querySelector('.customArchiveProduct__loop');

    const setCookies = (viewType) => {
      Cookies.set('productsViewType', viewType, {
        expires: 90
      });
    }

    const setViewType = (btn) => {
      if (btn.classList.contains('viewSwitch__btn--list')) {
        productList.classList.remove('grid');
        productList.classList.add('list');
        setCookies('list');
      } else if (btn.classList.contains('viewSwitch__btn--grid')) {
        productList.classList.remove('list');
        productList.classList.add('grid');
        setCookies('grid');
      }
    }
    
    if(viewSwitchBtn) {
      const viewSwitchButtons = viewSwitchBtn.querySelectorAll('.viewSwitch__btn');

      viewSwitchButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if(btn.classList.contains('viewSwitch__btn--active')) {
            return;
          }

          viewSwitchBtn.querySelector('.viewSwitch__btn--active').classList.remove('viewSwitch__btn--active');
          btn.classList.add('viewSwitch__btn--active');
          setViewType(btn);
        });
      });
    }
  });
}